import proxyMouseDownToParentContext from '../utils/helpers/proxy-mousedown-to-parent-context';

const documentMouseDownHandler = (e) => {
  proxyMouseDownToParentContext(e);
};

export default documentMouseDownHandler;
